var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDistance = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 36,
    viewBox: "0 0 15 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00006 2.99541C4.00006 1.34109 5.3432 0 7.00006 0C8.65691 0 10.0001 1.34109 10.0001 2.99541C10.0001 4.64973 8.65691 5.99082 7.00006 5.99082C5.3432 5.99082 4.00006 4.64973 4.00006 2.99541ZM2.00006 12.9801H12.0001C12.3467 12.9791 12.668 12.7989 12.8493 12.504C13.0306 12.209 13.046 11.8414 12.8901 11.5323L11.9401 9.63524C11.4301 8.62474 10.3933 7.98742 9.26006 7.98776H4.74006C3.60678 7.98742 2.57003 8.62474 2.06006 9.63524L1.11006 11.5323C0.954089 11.8414 0.969513 12.209 1.15082 12.504C1.33213 12.7989 1.65347 12.9791 2.00006 12.9801ZM9.61006 29.977H13.5001C13.643 29.9632 13.7853 30.0089 13.8933 30.1035C14.0012 30.1981 14.0652 30.333 14.0701 30.4763V34.3603C14.0776 34.565 13.9566 34.7527 13.767 34.8306C13.5773 34.9086 13.3591 34.8604 13.2201 34.7098L12.2201 33.7113C10.4688 35.6353 7.79268 36.4297 5.27314 35.7735C2.7536 35.1173 0.807052 33.119 0.220058 30.5861C0.192275 30.4385 0.228629 30.286 0.320058 30.1668C0.413414 30.0464 0.557577 29.9762 0.710058 29.977H1.71006C1.92167 29.9714 2.11393 30.0993 2.19006 30.2966C2.68111 32.0496 4.08889 33.3969 5.8639 33.8124C7.63891 34.228 9.49975 33.6459 10.7201 32.2935L9.26006 30.8257C9.12 30.6831 9.07857 30.4709 9.15474 30.2861C9.23091 30.1014 9.41002 29.9799 9.61006 29.977Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDistance, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/distance.12daf0fb.svg";
export { ForwardRef as ReactComponent };